export function shuffle(arra1) {
    var ctr = arra1.length, temp, index;

    while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
    }
    return arra1;
}

export function roundNumber(number, places) {
    return +(Math.round(number + "e+" + places)  + "e-" + places);
}

export function formatNumber(n, x) {
    return n.toFixed(x || 2).replace('.', ',');
};

export function copy(o) {
    var _out, v, _key;
    _out = Array.isArray(o) ? [] : {};
    for (_key in o) {
      v = o[_key];
      _out[_key] = (typeof v === "object") ? copy(v) : v;
    }
    return _out;
}

export function array_move_first(myArray, old_index) {
    const newArray = [];
    const layer = copy(myArray[old_index]);
    return myArray;
}

export function copy_float(obj) {
    let newObj = copy(obj);
    for (var name in obj) {
        if (obj.hasOwnProperty(name)) {
            newObj[name] = parseFloat(obj[name]);
        }
    }

    return newObj;
}

export function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

export function isEmpty(obj) {

    if (!isNaN(parseFloat(obj)) && isFinite(obj))
        return false;

    if (obj === false || obj === null || obj === undefined || obj === '')
        return true;

    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

// Trim Canvas Pixels Method
// https://gist.github.com/remy/784508
export function trim_canvas(c, text) {

    if (c.width <= 0 || c.height <= 0)
        return { canvas: c, posY: 0, word: text };


    const padding = 8;
            
    var ctx = c.getContext('2d'),

    // startTime = new Date().getTime(),
    // create a temporary canvas in which we will draw back the trimmed text
    copy = document.createElement('canvas').getContext('2d'),

    // Use the Canvas Image Data API, in order to get all the
    // underlying pixels data of that canvas. This will basically
    // return an array (Uint8ClampedArray) containing the data in the
    // RGBA order. Every 4 items represent one pixel.
    pixels = ctx.getImageData(0, 0, c.width, c.height),

    // total pixels
    l = pixels.data.length,
    
    // main loop counter and pixels coordinates
    i, x, y, r, c,

    width = c.width,
    height = c.height,

    // an object that will store the area that isn't transparent
    bound = { top: null, left: null, right: null, bottom: null };

    if (text !== null && text !== undefined && text !== '') {
        // for every pixel in there
        for (i = 0; i < l; i += 4) {

            // if the alpha value isn't ZERO (transparent pixel)
            if (pixels.data[i+3] !== 0) {

                // find it's coordinates
                x = (i / 4) % c.width;
                y = ~~((i / 4) / c.width);
            
                // store/update those coordinates
                // inside our bounding box Object
                if (bound.top === null) {
                    bound.top = y;
                }
                
                if (bound.left === null) {
                    bound.left = x; 
                } else if (x < bound.left) {
                    bound.left = x;
                }
                
                if (bound.right === null) {
                    bound.right = x; 
                } else if (bound.right < x) {
                    bound.right = x;
                }
                
                if (bound.bottom === null) {
                    bound.bottom = y;
                } else if (bound.bottom < y) {
                    bound.bottom = y;
                }
            }
        }
    }
    // actual height and width of the text
    // (the zone that is actually filled with pixels)
    var trimHeight = bound.bottom - bound.top,
        trimWidth = bound.right - bound.left;

    trimWidth += 3;
    trimHeight += 3;

    // get the zone (trimWidth x trimHeight) as an ImageData
    // (Uint8ClampedArray of pixels) from our canvas
    var trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

    // Draw back the ImageData into the canvas
    copy.canvas.width = trimWidth + padding * 2;
    copy.canvas.height = trimHeight + padding * 2;
    copy.putImageData(trimmed, padding, padding);

    // return the canvas element
    return { canvas: copy.canvas, posY: bound.top, word: text };
}


function rowBlank(imageData, width, y) {
    for (var x = 0; x < width; ++x) {
        if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
    }
    return true;
}

function columnBlank(imageData, width, x, top, bottom) {
    for (var y = top; y < bottom; ++y) {
        if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
    }
    return true;
}

export function trim_canvas_lettersacling(canvas, text) {
    var ctx = canvas.getContext("2d");
    var width = canvas.width;
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var top = 0, bottom = imageData.height, left = 0, right = imageData.width;

    while (top < bottom && rowBlank(imageData, width, top)) ++top;
    while (bottom - 1 > top && rowBlank(imageData, width, bottom - 1)) --bottom;
    while (left < right && columnBlank(imageData, width, left, top, bottom)) ++left;
    while (right - 1 > left && columnBlank(imageData, width, right - 1, top, bottom)) --right;

    var trimmed = ctx.getImageData(left, top, right - left, bottom - top);
    var copy = canvas.ownerDocument.createElement("canvas");
    var copyCtx = copy.getContext("2d");
    copy.width = trimmed.width;
    copy.height = trimmed.height;
    copyCtx.putImageData(trimmed, 0, 0);

    return { canvas: copy, posY: 0, word: '' };
}



export function setCaretPosition(elem, caretPos) {
    if(elem != null) {
        if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}


// WEBPACK FOOTER //
// ./src/functions.js